module.exports = [{
      plugin: require('/Volumes/BeingDrive/Developer/oroboro/internal/website/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Volumes/BeingDrive/Developer/oroboro/internal/website/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"trackingId":"UA-127765967-1","head":true,"anonymize":true,"respectDNT":true,"exclude":[]},
    }]
